import _react, { useContext } from "react";
import { Provider, useProviderProps } from "@react-spectrum/provider";
import { filterDOMProps } from "@react-aria/utils";
import { classNames, useDOMRef, useStyleProps } from "@react-spectrum/utils";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/fieldlabel/vars.css
var $c9fb1f4220ea2c59cb2e10f0e9828c6e$exports = {};
$c9fb1f4220ea2c59cb2e10f0e9828c6e$exports = {
  "spectrum-FieldLabel": "_spectrum-FieldLabel_36b9b",
  "spectrum-FieldLabel--positionSide": "_spectrum-FieldLabel--positionSide_36b9b",
  "spectrum-FieldLabel-requiredIcon": "_spectrum-FieldLabel-requiredIcon_36b9b",
  "spectrum-FieldLabel--alignEnd": "_spectrum-FieldLabel--alignEnd_36b9b",
  "spectrum-Field": "_spectrum-Field_36b9b",
  "spectrum-Field--positionTop": "_spectrum-Field--positionTop_36b9b",
  "spectrum-Field-field": "_spectrum-Field-field_36b9b",
  "spectrum-Field-field--multiline": "_spectrum-Field-field--multiline_36b9b",
  "spectrum-Field--positionSide": "_spectrum-Field--positionSide_36b9b",
  "spectrum-Form": "_spectrum-Form_36b9b",
  "spectrum-Form--positionSide": "_spectrum-Form--positionSide_36b9b",
  "spectrum-Form--positionTop": "_spectrum-Form--positionTop_36b9b",
  "spectrum-Form-itemLabel": "_spectrum-Form-itemLabel_36b9b",
  "is-disabled": "_is-disabled_36b9b"
};

let $d618213cd07bac427c632ce5c90d7$var$FormContext = /*#__PURE__*/_react.createContext({});

export function useFormProps(props) {
  let ctx = useContext($d618213cd07bac427c632ce5c90d7$var$FormContext);
  return _babelRuntimeHelpersEsmExtends({}, ctx, props);
}
const $d618213cd07bac427c632ce5c90d7$var$formPropNames = new Set(['action', 'autoComplete', 'encType', 'method', 'target', 'onSubmit']);
var $c9fb1f4220ea2c59cb2e10f0e9828c6e$$interop$default = $parcel$interopDefault($c9fb1f4220ea2c59cb2e10f0e9828c6e$exports);

function $d618213cd07bac427c632ce5c90d7$var$Form(props, ref) {
  props = useProviderProps(props);

  let {
    children,
    labelPosition = 'top',
    labelAlign = 'start',
    isRequired,
    necessityIndicator,
    isQuiet,
    isEmphasized,
    isDisabled,
    isReadOnly,
    validationState
  } = props,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(props, ["children", "labelPosition", "labelAlign", "isRequired", "necessityIndicator", "isQuiet", "isEmphasized", "isDisabled", "isReadOnly", "validationState"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let domRef = useDOMRef(ref);
  let ctx = {
    labelPosition,
    labelAlign,
    necessityIndicator
  };
  return /*#__PURE__*/_react.createElement("form", _babelRuntimeHelpersEsmExtends({}, filterDOMProps(otherProps, {
    labelable: true,
    propNames: $d618213cd07bac427c632ce5c90d7$var$formPropNames
  }), styleProps, {
    ref: domRef,
    className: classNames($c9fb1f4220ea2c59cb2e10f0e9828c6e$$interop$default, 'spectrum-Form', {
      'spectrum-Form--positionSide': labelPosition === 'side',
      'spectrum-Form--positionTop': labelPosition === 'top'
    }, styleProps.className)
  }), /*#__PURE__*/_react.createElement($d618213cd07bac427c632ce5c90d7$var$FormContext.Provider, {
    value: ctx
  }, /*#__PURE__*/_react.createElement(Provider, {
    isQuiet: isQuiet,
    isEmphasized: isEmphasized,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isRequired: isRequired,
    validationState: validationState
  }, children)));
}
/**
 * Forms allow users to enter data that can be submitted while providing alignment and styling for form fields.
 */


export const Form = /*#__PURE__*/_react.forwardRef($d618213cd07bac427c632ce5c90d7$var$Form);
//# sourceMappingURL=module.js.map
